<template>
    <div id="bene-details-container">
        <div class="card card-20 beneficiary-details fw-medium">
            <!-- COUNTRY -->
            <div class="display-flex align-items-center justify-content-space-between mb-sm">
                <div>
                    <div class="bene-details-title">{{ countryLabel }}</div>
                    <div class="bene-details-value">{{ homeCountryName }}</div>
                </div>
                <div>
                    <img class="" style="height: 17px" :src="getFlagImg(beneDetails[0].homeCountryId)" />
                </div>
            </div>

            <!-- TRANSFER TYPE -->
            <div class="display-flex align-items-center mb-sm">
                <div>
                    <div class="bene-details-title">{{ txTypeLabel }}</div>
                    <div class="bene-details-value">{{ txType }}</div>
                </div>
            </div>

            <!-- GOV SERVICES -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.govServices == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ govServicesLabel }}</div>
                    <div class="bene-details-value">{{ beneDetails[0].bank }}</div>
                </div>
            </div>

            <!-- BILLING CORPORATION -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.billCorp == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ billCorpLabel }}</div>
                    <div class="bene-details-value">{{ beneDetails[0].bank }}</div>
                </div>
            </div>

            <!-- BILLER CODE -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.billerCode == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ billerCodeLabel }}</div>
                    <div class="bene-details-value">{{ beneDetails[0].billerCode }}</div>
                </div>
            </div>

            <!-- FULL NAME -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.fullName == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ fullNameLabel }}</div>
                    <div class="bene-details-value">{{ beneDetails[0].fullName }}</div>
                </div>
            </div>

            <!-- NICKNAME -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.nickName == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ nickNameLabel }}</div>
                    <div class="bene-details-value">{{ beneDetails[0].dropDownDisplayName }}</div>
                </div>
            </div>

            <!-- BENEFICIARY TYPE-->
            <div class="display-flex align-items-center mb-sm" :class="showHide.beneficiaryType == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ beneficiaryTypeLabel }}</div>
                    <div class="bene-details-value">{{ beneficiaryType }}</div>
                </div>
            </div>

            <!-- BANK NAME -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.bankName == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ bankNameLabel }}</div>
                    <div class="bene-details-value">{{ beneDetails[0].bank }}</div>
                </div>
            </div>

            <!-- BANK NO -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.bankNo == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ bankNoLabel }}</div>
                    <div class="bene-details-value">{{ beneDetails[0].bankAccountNo }}</div>
                </div>
            </div>

            <!-- ID TYPE -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.idType == true && idType.trim() != '' ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ idTypeLabel }}</div>
                    <div class="bene-details-value">{{ idType }}</div>
                </div>
            </div>

            <!-- ID NO -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.idNo == true && idNo.trim() != '' ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ idNoLabel }}</div>
                    <div class="bene-details-value">{{ idNo }}</div>
                </div>
            </div>

            <!-- COLLECTION AGENT -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.collectionAgent == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ collectionAgentLabel }}</div>
                    <div class="bene-details-value">{{ beneDetails[0].collectionAgent }}</div>
                </div>
            </div>

            <!-- COLLECTION POINT -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.collectionPoint == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ collectionPointLabel }}</div>
                    <div class="bene-details-value">{{ beneDetails[0].collectionPoint }}</div>
                </div>
            </div>

            <!-- MEMBER TYPE -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.memberType == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ memberTypeLabel }}</div>
                    <div class="bene-details-value">{{ memberType }}</div>
                </div>
            </div>
            
            <!-- PROVINCE -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.province == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ provinceLabel }}</div>
                    <div class="bene-details-value">{{ provinceName }}</div>
                </div>
            </div>

            <!-- CITY -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.city == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ cityLabel }}</div>
                    <div class="bene-details-value">{{ cityName }}</div>
                </div>
            </div>

            <!-- STREET -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.street == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ streetLabel }}</div>
                    <div class="bene-details-value">{{ beneDetails[0].address.streetName }}</div>
                </div>
            </div>

            <!-- ADDRESS -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.address == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ addressLabel }}</div>
                    <div class="bene-details-value">{{ address }}</div>
                </div>
            </div>

            <!-- DR-1845 - BENEFICIARY COUNTRY (AML screening) -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.beneficiaryCountry == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ beneficiaryCountryLabel }}</div>
                    <div class="bene-details-value">{{ beneficiaryCountryName }}</div>
                </div>
            </div>

            <!-- DR-1845 - BENEFICIARY TOWN/CITY (AML screening) -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.beneficiaryTownCity == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ beneficiaryTownCityLabel }}</div>
                    <div class="bene-details-value">{{ beneficiaryTownCityName }}</div>
                </div>
            </div>

            <!-- REFERENCE NO. -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.refNo == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ refNoLabel }}</div>
                    <div class="bene-details-value">{{ refNo }}</div>
                </div>
            </div>

            <!-- PAYMENT PURPOSE -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.paymentPurpose == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ paymentPurposeLabel }}</div>
                    <div class="bene-details-value">{{ beneDetails[0].paymentPurpose }}</div>
                </div>
            </div>

            <!-- HOME TELEPHONE -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.homeNo == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ homeTelephoneLabel }}</div>
                    <div class="bene-details-value">{{ homeTelephone }}</div>
                </div>
            </div>

            <!-- MOBILE PHONE -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.mobileNo == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ mobileTelephoneLabel }}</div>
                    <div class="bene-details-value">{{ mobileTelephone }}</div>
                </div>
            </div>

            <!-- EMAIL -->
            <div class="display-flex align-items-center mb-sm" :class="showHide.email == true ? '' : ' d-none'">
                <div>
                    <div class="bene-details-title">{{ emailLabel }}</div>
                    <div class="bene-details-value">{{ beneDetails[0].email }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
            beneDetails : Array
        },
        mounted() {
            this.setDisplay();
        },
        data: function() {
            return {
                beneficiaryDetails      : [],

                countryLabel            : "",
                txTypeLabel             : "",
                govServicesLabel        : "",
                fullNameLabel           : "",
                nickNameLabel           : "",
                bankNameLabel           : "",
                bankNoLabel             : "",
                idTypeLabel             : "",
                idNoLabel               : "",
                memberTypeLabel         : "",
                paymentPurposeLabel     : "",
                emailLabel              : "",
                billCorpLabel           : "",
                billerCodeLabel         : "",
                homeTelephoneLabel      : "",
                mobileTelephoneLabel    : "",
                refNoLabel              : "",
                beneficiaryTypeLabel    : "",
                provinceLabel           : "",
                cityLabel               : "",
                streetLabel             : "",
                collectionAgentLabel    : "",
                collectionPointLabel    : "",
                addressLabel            : "",
                beneficiaryCountryLabel : "",
                beneficiaryTownCityLabel: "",

                homeCountryName         : "",
                txType                  : "",
                idType                  : "",
                idNo                    : "",
                memberType              : "",
                homeTelephone           : "",
                mobileTelephone         : "",
                refNo                   : "",
                beneficiaryType         : "",
                provinceName            : "",
                cityName                : "",
                address                 : "",
                beneficiaryCountryName  : "",
                beneficiaryTownCityName : "",

                showHide : {
                    govServices         : false,
                    fullName            : false,
                    nickName            : false,
                    bankName            : false,
                    bankNo              : false,
                    idType              : false,
                    idNo                : false,
                    memberType          : false,
                    paymentPurpose      : false,
                    email               : false,
                    billCorp            : false,
                    billerCode          : false,
                    homeNo              : false,
                    mobileNo            : false,
                    refNo               : false,
                    beneficiaryType     : false,
                    province            : false,
                    city                : false,
                    street              : false,
                    collectionAgent     : false,
                    collectionPoint     : false,
                    address             : false,
                    beneficiaryCountry  : false,
                    beneficiaryTownCity : false,
                }
            }
        },
        computed: {
            ...mapGetters('beneficiary', [
                'homeCountryList',
                'provinceList',
                'cityList',
                'allCountryList'
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'loadAllCountryList'
            ]),

            async setDisplay(){
                const self              = this;
                self.showPreloader();
                const deliveryMethodId  = self.beneDetails[0].deliveryMethodId;
                const bankTypeId        = self.beneDetails[0].bankTypeId;
                const nickname          = self.beneDetails[0].dropDownDisplayName;
                const homeCountryId     = self.beneDetails[0].homeCountryId;
                const bankId            = self.beneDetails[0].bankId;
                const homeIDD           = self.beneDetails[0].phoneCountryIDDCode;
                const homeNo            = self.beneDetails[0].phone;
                const mobileIDD         = self.beneDetails[0].mobileCountryIDDCode;
                const mobileNo          = self.beneDetails[0].mobile;
                //const email             = self.beneDetails[0].email;
                let refNo               = self.beneDetails[0].referenceNo;
                const provinceId        = self.beneDetails[0].address.provinceId;
                const cityId            = self.beneDetails[0].address.cityId;
                const street            = self.beneDetails[0].address.streetName;
                const address           = self.beneDetails[0].address.streetAddress || "";

                // GET HOME COUNTRY NAME
                const homeCountryDetails = await self.homeCountryList.filter(country => country.id == homeCountryId);
                self.homeCountryName    = homeCountryDetails[0].name;

                // DR-1845 - Beneficiary Country / Town-City (AML screening), sourced
                // from additionalFieldList (fieldId 39 = country, fieldId 37 =
                // town-city). Shown whenever previously saved, regardless of delivery
                // method - the create/modify form's address section is scoped by
                // destination corridor, not by delivery method, so it can be present
                // for any of the branches below.
                const additionalFieldList = self.beneDetails[0].additionalFieldList;
                if(additionalFieldList != undefined && additionalFieldList.length > 0) {
                    const beneCountryField = additionalFieldList.find(f => f.fieldId == 39);
                    if(beneCountryField && beneCountryField.fieldValue) {
                        await self.loadAllCountryList();
                        const beneCountryId = parseInt(beneCountryField.fieldValue);
                        const beneCountry   = self.allCountryList.find(c => c.id == beneCountryId);
                        self.beneficiaryCountryName     = beneCountry ? beneCountry.name : "";
                        self.showHide.beneficiaryCountry = self.beneficiaryCountryName != "";
                    }
                    const townCityField = additionalFieldList.find(f => f.fieldId == 37);
                    if(townCityField && townCityField.fieldValue) {
                        self.beneficiaryTownCityName     = townCityField.fieldValue;
                        self.showHide.beneficiaryTownCity = true;
                    }
                }

                // GET PROVINCE NAME
                if(provinceId > 0 && self.provinceList.length > 0){
                    const provinceDetails = await self.provinceList.filter(province => province.key == provinceId);
                    self.provinceName    = provinceDetails[0].value;
                }

                // GET CITY NAME
                if(cityId > 0 && self.cityList.length > 0){
                    const cityDetails = await self.cityList.filter(city => city.key == cityId);
                    self.cityName    = cityDetails[0].value;
                }

                self.idType             = self.beneDetails[0].identificationType || "";
                self.idNo               = self.beneDetails[0].identificationNo || "";
                self.txType             = self.beneDetails[0].deliveryMethod;
                self.memberType         = self.beneDetails[0].beneficiaryPhilGovLink ? self.beneDetails[0].beneficiaryPhilGovLink.memberTypeName : "";
                self.homeTelephone      = homeIDD+" "+homeNo;
                self.mobileTelephone    = mobileIDD+" "+mobileNo;
                self.refNo              = self.beneDetails[0].referenceNo;
                self.address            = address;
                
                // COMMON LABEL
                self.countryLabel                   = self.$t('beneficiary-country');
                self.txTypeLabel                    = self.$t('beneficiary-transfer-type');
                self.nickNameLabel                  = self.$t('beneficiary-nickname-label');
                self.paymentPurposeLabel            = self.$t('beneficiary-payment-purpose');
                self.homeTelephoneLabel             = self.$t('beneficiary-home-no');
                self.mobileTelephoneLabel           = self.$t('beneficiary-mobile-no');
                self.emailLabel                     = self.$t('general-text-email-address');
                self.collectionAgentLabel           = self.$t('beneficiary-collection-agent');
                self.collectionPointLabel           = self.$t('beneficiary-collection-point');
                self.addressLabel                   = self.$t('beneficiary-beneficiary-address');
                self.beneficiaryCountryLabel        = self.$t('beneficiary-bene-country');
                self.beneficiaryTownCityLabel       = self.$t('beneficiary-town-city');

                // 0 - BILL PAYMENT
                if(deliveryMethodId == 0){
                    self.txType                     = self.$t('general-text-dm-0');
                    
                    self.billCorpLabel              = self.$t('beneficiary-bill-corp');
                    self.billerCodeLabel            = self.$t('beneficiary-bill-code');
                    self.fullNameLabel              = self.$t('beneficiary-bill-account-name');
                    self.bankNoLabel                = self.$t('beneficiary-bill-account-no');

                    self.showHide.billCorp          = true;
                    self.showHide.billerCode        = true;
                    self.showHide.fullName          = true;
                    //self.showHide.nickName          = nickname.trim() != "" ? true : false;
                    self.showHide.bankNo            = true;
                    //self.showHide.homeNo            = homeNo.trim() != "" ? true : false;
                    //self.showHide.mobileNo          = mobileNo.trim() != "" ? true : false;
                    //self.showHide.email             = email.trim() != "" ? true : false;

                    // 167 - PHILIPPINES
                    if(homeCountryId == 167){
                        refNo                       = self.beneDetails[0].bankNotes;
                        self.refNo                  = self.beneDetails[0].bankNotes;
                        self.refNoLabel             = self.$t('general-text-bill-reference');

                        self.showHide.billerCode    = false;
                        self.showHide.refNo         = refNo.trim() != "" ? true : false;
                    }
                }

                // 1 - BANK TRANSFER
                else if(deliveryMethodId == 1){
                    self.fullNameLabel              = self.$t('beneficiary-fullname');
                    self.bankNameLabel              = self.$t('beneficiary-bank');
                    self.bankNoLabel                = self.$t('beneficiary-bank-account-no');

                    self.showHide.fullName          = true;
                    self.showHide.bankName          = true;
                    self.showHide.bankNo            = true;
                    self.showHide.paymentPurpose    = true;

                    // 1 - PHIL GOV
                    if(bankTypeId == 1){
                        self.txType                 = self.$t('general-text-gov-services');

                        self.govServicesLabel       = self.$t('general-text-gov-services');
                        self.memberTypeLabel        = self.$t('beneficiary-phil-gov-member-type');

                        self.showHide.bankName      = false;
                        self.showHide.paymentPurpose= false;
                        self.showHide.govServices   = true;
                        self.showHide.memberType    = true;
                        

                        // 4520 - PhilHealth
                        if(bankId == 4520) {
                            self.bankNoLabel        = self.$t('beneficiary-phil-health-number');

                            self.showHide.email     = true;
                        }
                        // 4521 - Pag-IBIG
                        else if(bankId == 4521) {
                            self.bankNoLabel        = self.$t('beneficiary-pag-ibig-number');
                        }
                        // 4522 - SSS
                        else if(bankId == 4522) {
                            self.bankNoLabel        = self.$t('beneficiary-sss-number');
                        }
                    }

                    // 2 - WALLET
                    else if(bankTypeId == 2){
                        self.txType                 = self.$t('general-text-wallet');
                        self.bankNameLabel          = self.$t('beneficiary-wallet-name');
                        self.bankNoLabel            = self.$t('sendmoney-account-number');

                        self.showHide.nickName      = nickname.trim() != "" ? true : false;
                    }
                }

                
                // 3 - COLLECTION
                else if(deliveryMethodId == 3){
                    self.fullNameLabel              = self.$t('beneficiary-fullname');
                    self.idTypeLabel                = self.$t('beneficiary-beneficiary-id-type');
                    self.idNoLabel                  = self.$t('beneficiary-beneficiary-id-no');

                    self.showHide.fullName          = true;
                    self.showHide.idType            = true;
                    self.showHide.idNo              = true;
                    self.showHide.collectionAgent   = true;
                    self.showHide.collectionPoint   = true;
                    self.showHide.address           = address.trim() != "" ? true : false;
                    self.showHide.paymentPurpose    = true;
                }

                // 4 - DOOR TO DOOR
                else if(deliveryMethodId == 4){
                    self.txType                     = self.$t('general-door-to-door-text');

                    self.fullNameLabel              = self.$t('general-text-recipient-name');
                    self.idTypeLabel                = self.$t('beneficiary-beneficiary-id-type');
                    self.provinceLabel              = self.$t('beneficiary-province');
                    self.cityLabel                  = self.$t('beneficiary-city');
                    self.streetLabel                = self.$t('beneficiary-street');

                    self.showHide.fullName          = true;
                    self.showHide.idType            = true;
                    self.showHide.province          = provinceId > 0 ? true : false;
                    self.showHide.city              = cityId > 0 ? true : false;
                    self.showHide.street            = street.trim() != "" ? true : false;
                    self.showHide.paymentPurpose    = true;
                    
                }

                // 6 - CASH CARD
                else if(deliveryMethodId == 6){
                    self.txType                     = self.beneDetails[0].transactionType;

                    self.fullNameLabel              = self.$t('beneficiary-fullname');
                    self.bankNameLabel              = self.$t('beneficiary-bank');
                    self.bankNoLabel                = self.$t('beneficiary-cash-card-no');

                    self.showHide.fullName          = true;
                    //self.showHide.nickName          = nickname.trim() != "" ? true : false;
                    self.showHide.bankName          = true;
                    self.showHide.bankNo            = true;
                    self.showHide.paymentPurpose    = true;
                    //self.showHide.homeNo            = homeNo.trim() != "" ? true : false;
                    //self.showHide.mobileNo          = mobileNo.trim() != "" ? true : false;
                    //self.showHide.email             = email.trim() != "" ? true : false;

                    if(homeCountryId == 18){
                        self.txType                 = self.$t('beneficiary-bkash');
                        self.bankNoLabel            = self.$t('beneficiary-bkash-no');
                    }
                }

                // 9 - UPI
                else if(deliveryMethodId == 9){
                    self.txType                     = self.beneDetails[0].deliveryMethod;

                    self.fullNameLabel              = self.$t('beneficiary-fullname');
                    self.beneficiaryTypeLabel       = self.$t('beneficiary-beneficiary-type');
                    self.beneficiaryType            = self.beneDetails[0].beneficiaryTypeId == 1 ? self.$t('general-text-individual') : self.beneDetails[0].beneficiaryTypeId == 2 ? self.$t('general-text-corporate') : self.$t('general-text-individual');
                    self.bankNoLabel                = self.$t('beneficiary-virtual-payment-address');

                    const additionalList = self.beneDetails[0].additionalFieldList
                    if(additionalList != undefined && additionalList.length > 0) {
                        Object.keys(additionalList).forEach(key => {
                            if(additionalList[key].fieldId == 7) { // VPA
                                self.beneDetails[0].bankAccountNo    = additionalList[key].fieldValue
                            }
                        })
                    }

                    self.showHide.fullName          = true;
                    //self.showHide.nickName          = nickname.trim() != "" ? true : false;
                    self.showHide.beneficiaryType   = true;
                    self.showHide.bankNo            = true;
                    self.showHide.paymentPurpose    = true;
                    //self.showHide.homeNo            = homeNo.trim() != "" ? true : false;
                    //self.showHide.mobileNo          = mobileNo.trim() != "" ? true : false;
                    //self.showHide.email             = email.trim() != "" ? true : false;
                }

                self.hidePreloader();
            }
        }
    }
</script>